import { useState, useEffect } from "react";
import { collection, getDocs, updateDoc, doc } from "firebase/firestore";
import HeartIcon from "../../assets/techStackIcons/heartIcon";
import { db } from "../../utils/firebase";
import "./styles.css";
import { Link } from "react-router-dom";

function Projects() {
  const [projectsData, setProjectsData] = useState([]);

  useEffect(() => {
    const fetchProjects = async () => {
      const querySnapshot = await getDocs(collection(db, "projects"));
      const projects = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setProjectsData(projects);
    };

    fetchProjects();
  }, []);

  return (
    <div className="projectsContainer fade-in">
      <div className="allProjects">
        {projectsData
          .filter((project) => project.isVisible)
          .map((project, index) => (
            <div className="project" key={index} tabIndex={0}>
              <ProjectDiv
                image={project.coverPhoto}
                title={project.title}
                url={project.URL}
                projectId={project.id}
                likes={project.likes}
              />
            </div>
          ))}
        <br />
        <Link to={"/"} className="homeLink">
          home
        </Link>
      </div>
    </div>
  );
}

// eslint-disable-next-line react/prop-types
const ProjectDiv = ({ image, title, url, projectId, likes }) => {
  let likedProjects = JSON.parse(localStorage.getItem("likedProjects"));
  if (!Array.isArray(likedProjects)) {
    likedProjects = [];
  }
  const [liked, setLiked] = useState(likedProjects.includes(projectId));
  const [likeCount, setLikeCount] = useState(likes);

  const handleLikeClick = async () => {
    let updatedLikedProjects;
    let newLikeCount;
    if (liked) {
      updatedLikedProjects = likedProjects.filter((id) => id !== projectId);
      newLikeCount = likeCount - 1;
    } else {
      updatedLikedProjects = [...likedProjects, projectId];
      newLikeCount = likeCount + 1;
    }
    localStorage.setItem("likedProjects", JSON.stringify(updatedLikedProjects));
    setLiked(!liked);
    setLikeCount(newLikeCount);

    // Update Firestore document
    const projectRef = doc(db, "projects", projectId);
    await updateDoc(projectRef, {
      likes: newLikeCount,
    });
  };

  return (
    <div className="projectBody">
      <Link to={url} target="_blank" rel="noopener noreferrer">
        <img src={image} alt="missing" />
      </Link>
      <h2 className="projectTitle">{title}</h2>
      <div>
        <Link to={`/projects/${projectId}`} className="projectLink">
          details
        </Link>
        <button onClick={handleLikeClick} className={`${liked ? "liked" : ""}`}>
          <HeartIcon style={{ fill: liked ? "#ff0000" : "#eddb1d" }} />{" "}
          {liked ? likeCount : null}
        </button>
      </div>
    </div>
  );
};

export default Projects;
